'use client';

import { c as _c } from "react/compiler-runtime";
import { useAuth } from '@morfi/backend-sdk-v2/client';
import { useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useTheme } from 'next-themes';
import type { JSX } from 'react';
import { LiquidGlassNav, type LiquidGlassNavItem } from '@/components/layout/liquid-glass-nav';
import { isCoreMobileNavSurface, isNavItemActive, mobileNavigationItems, navHrefWithCategory } from '@/config/navigation';
import { useFeatureGate } from '@/hooks/use-feature-gate';
import { usePathname } from '@/i18n/navigation';

// ⚠️ DO NOT change the dock's 4px bottom offset to a Tailwind spacing token
// (e.g. bottom-1) or any other value. The exact 4px literal is load-bearing:
// tokenizing it breaks Safari scroll on the main feed. Keep it verbatim.
const DOCK_CLASS = 'pointer-events-none fixed inset-x-0 bottom-[4px] z-sticky h-28 lg:hidden'; // ARBITRARY: exact 4px dock offset — DO NOT CHANGE, breaks Safari scroll on the main feed

export function MobileNav() {
  const $ = _c(6);
  const pathname = usePathname();
  const activeCategory = useSearchParams().get("category");
  const t = useTranslations("nav");
  const {
    user,
    isAuthenticated
  } = useAuth();
  const {
    resolvedTheme
  } = useTheme();
  const userId = user?.id ?? null;
  const liveEventsEnabled = useFeatureGate("live_events") === true;
  if (!isCoreMobileNavSurface(pathname, userId)) {
    return null;
  }
  const mobileItems = mobileNavigationItems(liveEventsEnabled, isAuthenticated);
  const items = mobileItems.map(item => {
    const label = item.key.replace("nav.", "") as keyof IntlMessages['nav'];
    const baseHref = item.key === "nav.portfolio" && user?.id ? `/portfolio/${user.id}` : item.href;
    return {
      key: item.key,
      label: t(label),
      icon: item.icon,
      href: navHrefWithCategory(baseHref, activeCategory)
    };
  });
  let t0;
  if ($[0] !== pathname) {
    t0 = item_0 => isNavItemActive(item_0, pathname);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const activeIndex = mobileItems.findIndex(t0);
  const t1 = resolvedTheme === "light" ? "light" : "dark";
  let t2;
  if ($[2] !== activeIndex || $[3] !== items || $[4] !== t1) {
    t2 = <LiquidGlassNav items={items} activeIndex={activeIndex} theme={t1} scale={0.9} className={DOCK_CLASS} />;
    $[2] = activeIndex;
    $[3] = items;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}